import { createDraftSafeSelector, createSelector } from '@reduxjs/toolkit';
import { RootState } from '../Store';

const selectedReducer = (state: RootState) => state.sheetConfig;

export const selectActiveSheetName = createSelector(
  selectedReducer,
  (sheetConfigState) => sheetConfigState.activeSheetName
);

export const selectSheetConfig = createSelector(
  selectedReducer,
  (sheetConfigState) => sheetConfigState.sheetConfig
);

export const selectAdminColumns = createSelector(
  selectedReducer,
  (sheetConfigState) => sheetConfigState.adminColumns
);

export const selectRequiredAdminColumns = createSelector(
  selectedReducer,
  (sheetConfigState) => sheetConfigState.requiredAdminColumns
);

// this is selector for file title
export const selectFileTitle = createDraftSafeSelector(
  selectedReducer,
  (sheetConfigState) => sheetConfigState.data.fileTitle
);
